import { Button, Form, Select, Slider, Switch } from "antd";
import GrayCheckMark from "../../assets/icons/GrayCheckMark";
import GreenCheckMark from "../../assets/icons/GreenCheckMark";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

const { Option } = Select;

export default function AssignProductModal({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps) {
  const onFinish = (values: any) => {
    console.log("Form Values:", values);
  };

  return (
    <CustomModal
      {...rest}
      title="Assign Product"
      handleClose={handleClose}
      width={400}
      footer={null}
    >
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Select Product"
          name="product"
          rules={[{ required: true }]}
        >
          <Select placeholder="Select">
            <Option value="product1">Product 1</Option>
            <Option value="product2">Product 2</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Select Package"
          name="package"
          rules={[{ required: true }]}
        >
          <Select placeholder="Package #1">
            <Option value="package1">Package #1</Option>
            <Option value="package2">Package #2</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Additional Features" name="features">
          <Select placeholder="Select">
            <Option value="feature1">Feature 1</Option>
            <Option value="feature2">Feature 2</Option>
          </Select>
        </Form.Item>

        <div className="my-4">
          <div className="flex justify-between items-center">
            <div className="text-lg font-semibold">Package #1</div>
            <div className="text-2xl font-bold mt-1">
              ৳7999 <span className="text-base font-normal">/Yearly</span>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div className="mt-1 text-gray-600">For 15 Employees</div>
            <div className="flex items-center gap-2 mt-2">
              <Switch /> <span>Custom</span>
            </div>
          </div>

          <div className="mt-4">
            <h4 className="font-semibold mb-2">Adjust Employees:</h4>
            <Slider defaultValue={15} min={1} max={100} />
          </div>

          <div className="mt-4">
            <h4 className="font-semibold mb-2">Features:</h4>
            <ul className="space-y-1">
              <li className="flex items-center gap-2">
                <GreenCheckMark /> <span>Features title will go here</span>
              </li>
              <li className="flex items-center gap-2">
                <GreenCheckMark /> <span>Features title will go here</span>
              </li>
              <li className="flex items-center gap-2">
                <GreenCheckMark /> <span>Features title will go here</span>
              </li>
              <li className="flex items-center gap-2">
                <GreenCheckMark /> <span>Features title will go here</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="text-[#AFBACA]">
                  <GrayCheckMark />
                </div>
                <span>Features title will go here</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex gap-2 mt-6">
          <Button>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </CustomModal>
  );
}
